import React from "react";
import classes from "./BookNowBtn.module.css";
import { images } from "../../assets/img";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import '../../index.css'

const BookNowBtn = (props) => {
  const { isShowArrow = false, title = "CALL TO BOOK", style, type='button' } = props;

  const onClickBookNow = () => {
    if (props?.onClick) {
      props?.onClick?.();
      return;
    }
    window.location.href = `tel:${NAIL_SHOP_INFO.tel}`;
  };

  return (
    <button type={type} onClick={onClickBookNow} className={`${classes.button} ${style || ""} linear-gradient-bg`}>
      <div className={`${classes.bookNowBtn} ${style || ""}`}>
        <h3 className={classes["change-color-on-hover"]}>{title}</h3>
        {isShowArrow ? (
          <img alt={"right-arrow"} src={images.leftArrow} />
        ) : null}
      </div>
    </button>
  );
};

export default BookNowBtn;
